import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';


const KEY_ACTION = ActionType.ApplyPendingChangesRequest;
const ACTIONS    = [
  ActionType.ApplyPendingChangesRequest,
  ActionType.ApplyPendingChangesResponse,
  ActionType.ApplyPendingChangesError,
];


type Payload = string;

type Meta = {
  projectId: number;
  participantId: number;
};


/**
 * Dispatch this action to add a dev plan item
 */
export const applyPendingChangesAction = (
  projectId: number,
  participantId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.ApplyPendingChanges,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({
    projectId:     projectId,
    participantId: participantId,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['projectSummary', 'followupSurveyCreated'], true, successState);
};


export const applyPendingChangesReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
